import { useState, useEffect } from 'react';
import { Conversation } from '@/features/conversations/conversations.types';
import {
  AgentType,
  AgentStatus,
} from '@/features/conversations/conversations.types';

interface UseAgentStateProps {
  conversation?: Conversation;
}

interface UseAgentStateReturn {
  activeAgentType: AgentType;
  agentStatus: AgentStatus;
  setActiveAgentType: (type: AgentType) => void;
  setAgentStatus: (status: AgentStatus) => void;
}

export const useAgentState = ({
  conversation,
}: UseAgentStateProps): UseAgentStateReturn => {
  const [activeAgentType, setActiveAgentType] = useState<AgentType>(
    conversation?.has_agent_active ? 'ai' : 'human',
  );

  const [agentStatus, setAgentStatus] = useState<AgentStatus>(
    conversation?.has_agent_active ? 'active' : 'inactive',
  );

  // Update agent state when conversation changes
  useEffect(() => {
    if (conversation) {
      setActiveAgentType(conversation.has_agent_active ? 'ai' : 'human');
      setAgentStatus(conversation.has_agent_active ? 'active' : 'inactive');
    }
  }, [conversation?.has_agent_active]);

  return {
    activeAgentType,
    agentStatus,
    setActiveAgentType,
    setAgentStatus,
  };
};
